// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__HJ2Kr","loadingMessage":"HomePage_loadingMessage__trH76"};